const classes = {
  noScroll: 'no-scroll'
}

const elements = {
  body: null
}

const scroll = () => {
  elements.body = document.body

  return {
    enabledScroll: () => elements.body.classList.remove(classes.noScroll),
    disabledScroll: () => elements.body.classList.add(classes.noScroll),
  }
}

export default scroll
